import React, { useEffect, useState } from "react";
import Title from "antd/es/typography/Title";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useGetUserPersonalInfoQuery } from "shared/api";
import { Sidebar } from "../Sidebar";
import UserAvatar from "./UserAvatar";
import SlidingSidebarFooter from "../Sidebar/ui/SlidingSidebar";
import { RenderClearFiltersButton } from "../RenderClearFiltersButton";

interface PageProps {
  children: React.ReactNode;
  titleChildren?: React.ReactNode;
  title: string;
  buttonTitle?: string;
  onClick?: () => void;
  hideTitle?: boolean;
  isCenteredTitle?: boolean;
  isVisibleClearFiltersButton?: string | boolean;
  clearAllFilters?: () => void;
  isCalendar?: boolean;
  calendarTitle?: string;
  onCalendarClick?: () => void;
}

const Page = ({
  children,
  title,
  buttonTitle,
  onClick,
  hideTitle = false,
  isCenteredTitle,
  isVisibleClearFiltersButton,
  clearAllFilters,
  calendarTitle,
  isCalendar,
  onCalendarClick,
  titleChildren,
}: PageProps) => {
  const { data: getPersonalInfo, refetch } = useGetUserPersonalInfoQuery();
  const [isFooterOpen, setIsFooterOpen] = useState(false);

  const themeColor = JSON.parse(
    localStorage.getItem("color-theme") || '"#002F5F"'
  );

  const handleUserSidebar = (value: boolean) => {
    setIsFooterOpen(value);
  };

  useEffect(() => {
    refetch();
  }, [localStorage.getItem("access_token")]);

  return (
    <div className="w-screen h-full flex">
      <Sidebar isOpenSidebar getPersonalInfo={getPersonalInfo} />

      <div className="w-full">
        <div className="w-full p-3.75 overflow-scroll">
          <div
            className={`flex items-center ${
              hideTitle ? "justify-end" : "justify-between"
            }`}
          >
            {hideTitle ? null : (
              <div className="flex gap-3 items-center">
                <Title
                  className={`capitalize ${
                    isCenteredTitle ? "text-center w-full" : ""
                  }`}
                >
                  {title}
                </Title>

                <div className="!mb-4">{titleChildren}</div>
              </div>
            )}

            <UserAvatar handleUserSidebar={handleUserSidebar} />
          </div>

          {buttonTitle && (
            <div className="flex gap-2 items-center">
              <Button
                type="primary"
                className="mb-2"
                style={{ backgroundColor: themeColor }}
                onClick={onClick}
              >
                {buttonTitle}
                <PlusOutlined className="mt-1" />
              </Button>
              {isCalendar && (
                <Button
                  onClick={onCalendarClick}
                  type="primary"
                  className="mb-2"
                  style={{ backgroundColor: themeColor }}
                >
                  {calendarTitle}
                </Button>
              )}
            </div>
          )}

          {isVisibleClearFiltersButton && (
            <RenderClearFiltersButton
              className={`!mb-0 ${!isCalendar ? "max-w-fit" : ""}`}
              onClick={clearAllFilters}
            />
          )}

          {children}
        </div>
      </div>
      <SlidingSidebarFooter
        isOpen={isFooterOpen}
        onClose={() => setIsFooterOpen(false)}
        getPersonalInfo={getPersonalInfo}
      />
    </div>
  );
};

export { Page };
